import { actions } from './techpack.actions'
import { getters } from './techpack.getters'
import { state } from './techpack.state'
import { mutations } from './techpack.mutations'

export default { actions, getters, state, mutations, namespaced: true }
